module.exports = __webpack_public_path__ + "static/img/gkk.e319211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gkk.jpg
// module id = 67Lo
// module chunks = 1